var baseStyle = {
  textStyle: 'label',
  mr: 3,
  mb: 1,
  fontSize: 'md'
};
var Label = {
  baseStyle: baseStyle
};
export { Label as default };